import "babel-polyfill";
import "whatwg-fetch";
import 'url-search-params-polyfill';

import {useContext} from "react";
import {SearchContext} from "./SearchContext.js";
import { decodeHTML } from "../helpers.mjs";

const CreatorLink = ({creator, type, typeD, noLink=false}) => {
    
    const {doSearchTermSearch} = useContext(SearchContext);

    const creatorNameArray = decodeHTML(creator).split(",")
    let creatorText = "";
    if(creatorNameArray.length > 1) {
        creatorText = creatorNameArray[1] + " " + creatorNameArray[0];
    } else {
        creatorText = creator;
    }

    creatorText = creatorText.trim();

    if(noLink) {
        return <>
            {type != "other" && <span>{creatorText}{typeD != "Author" && <> ({typeD})</>}</span>}
            {type == "other" && <span>{creatorText}</span>}
        </>
    } else {
        return <>
            {type != "other" && <p className="authorsLink" onClick={e => {
                e.preventDefault();
                doSearchTermSearch(creator, type);
            }}>{creatorText}{typeD != "Author" && <> ({typeD})</>}</p>}
            {type == "other" && <span>{creatorText}</span>}
        </>
    }
}

export default CreatorLink;